import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { debug } from '@shared/helpers/debug';
import { PurchasedNumberFormatter } from '@phone-number/services/formatter/PurchasedNumberFormatter';

class RecipientServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(database_id, params) {
    return this.http
      .get(`/${database_id}/recipients`, { params: params })
      .then(res => PurchasedNumberFormatter.formatItemWithPaginate(res));
  }

  editItem(database_id, recipient_id, params) {
    return this.http.put(`/${database_id}/recipients/${recipient_id}`, params);
  }
  removeItemModal(path_params = {}) {
    const { database_id = null, recipient_id = null } = path_params;
    if (database_id && recipient_id) {
      return this.http.delete(`/${database_id}/recipients/${recipient_id}`);
    } else {
      debug.warn(`Missed database_id: ${database_id} and recipient_id ${recipient_id}`);
    }
  }

  createItem(database_id, params) {
    return this.http.post(`/${database_id}/recipients`, params);
  }
  sorting(database_id, params) {
    return this.http.get(`/${database_id}/sort`, params);
  }
  export(database_id, params) {
    return this.http.post(`/${database_id}/export`, params);
  }
  importFiles(file) {
    return this.http.post('/import/files', file);
  }
  upload(params) {
    return this.http.post('upload', params);
  }
  getImportData(database_id, file_id, params) {
    return this.http.get(`/${database_id}/import/files/${file_id}/content`, params);
  }
  saveImport(database_id, file_id, params) {
    return this.http.post(`/${database_id}/import/files/${file_id}`, params);
  }
  downloadFile(path) {
    return this.pure_http.get(path);
  }
}

export const RecipientService = new RecipientServiceClass({
  api_version: 3,
  resource: 'databases'
});
